var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgExclamationSolid = function SvgExclamationSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14.667A6.667 6.667 0 118 1.333a6.667 6.667 0 010 13.334zm-.667-10a.667.667 0 111.334 0V8a.667.667 0 11-1.334 0V4.667zM8 10a.667.667 0 100 1.333A.667.667 0 008 10z"
  })));
};
export default SvgExclamationSolid;